import { AsyncPipe } from '@angular/common';
import { Component, inject } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';
import { dsDtos } from '@vectronic/openApi-admin';
import { CardComponent, DIALOG_WIDE_CONFIG, ParameterViewComponent } from '@vectronic/ui';
import { ParameterDataService } from '@vectronic/util';
import { Observable } from 'rxjs';

@Component({
  selector: 'rc-parameter-reset-dialog',
  templateUrl: './parameter-reset-dialog.component.html',
  styleUrls: ['./parameter-reset-dialog.component.scss'],
  imports: [CardComponent, MatButton, MatIcon, ParameterViewComponent, AsyncPipe],
})
export class ParameterResetDialogComponent {
  parameterDataService = inject(ParameterDataService);
  data: {
    parameterDataList?: dsDtos.ParameterData[];
    selectedCollarIds?: number[];
    parameters$?: Observable<dsDtos.Parameter[]>;
    categories$?: Observable<dsDtos.ParameterCategory[]>;
    subsystems$?: Observable<dsDtos.Subsystem[]>;
  } = inject(MAT_DIALOG_DATA);
  dialogRef = inject(MatDialogRef<ParameterResetDialogComponent>);

  constructor() {
    this.parameterDataService.init(this.data.parameterDataList);
  }

  get joinedSelectedCollarIds() {
    return this.data?.selectedCollarIds?.join(', ');
  }

  get selectedCollarIdsAsString() {
    return this.data?.selectedCollarIds?.map((selectedCollarId) => selectedCollarId.toString());
  }

  onConfirm() {
    this.dialogRef.close(true);
  }

  onCancel() {
    this.dialogRef.close(false);
  }

  onResized(isFullScreen: boolean) {
    if (isFullScreen) {
      this.dialogRef.updateSize('100vw', '100vh');
    } else {
      this.dialogRef.updateSize(DIALOG_WIDE_CONFIG.width, DIALOG_WIDE_CONFIG.height);
    }
  }
}
